export default __webpack_public_path__ + "static/media/Diggers_00.ea7d51a6.png";